import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { useTheme } from '@mui/material/styles';

export const ProductOffersPageSkeleton = () => {
  const theme = useTheme();

  return (
    <Box sx={{ pb: theme.novus.novusFooterHeight }}>
      {/* TopNavBar skeleton */}
      <Box
        sx={{
          height: '67px',
          bgcolor: theme.novus.primaryBrandBlue,
          px: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 1100,
        }}
      >
        <Skeleton variant="rectangular" width={130} height={30} sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
        <Skeleton variant="circular" width={36} height={36} sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
      </Box>

      {/* AddressHeader skeleton */}
      <Box
        sx={{
          bgcolor: theme.novus.addressHeaderBg,
          height: '476px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: { lg: '90px' },
            width: '100%',
            maxWidth: '1440px',
            px: { xs: '20px', xl: '100px' },
          }}
        >
          <Box
            sx={{
              width: { xs: '100%', lg: '576px' },
              flexShrink: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '30px',
            }}
          >
            <Box>
              <Skeleton variant="text" width="90%" height={55} sx={{ bgcolor: 'rgba(255,255,255,0.4)' }} />
              <Skeleton variant="text" width="60%" height={55} sx={{ bgcolor: 'rgba(255,255,255,0.4)' }} />
            </Box>
            <Box
              sx={{
                bgcolor: 'rgba(255,255,255,0.5)',
                borderRadius: '10px',
                p: '15px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <Skeleton variant="text" width={220} height={28} />
              <Skeleton variant="text" width={300} height={24} />
              <Skeleton variant="rectangular" width={180} height={42} sx={{ borderRadius: '5px', mt: '10px' }} />
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', lg: 'flex' },
              flexShrink: 1,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Skeleton
              variant="rectangular"
              width={400}
              height={300}
              sx={{ borderRadius: '10px', bgcolor: 'rgba(255,255,255,0.3)' }}
            />
          </Box>
        </Box>
      </Box>

      {/* PlansSection skeleton */}
      <Box sx={{ p: '75px 100px', bgcolor: theme.novus.bgCyanDark }}>
        <Skeleton variant="text" width={450} height={40} sx={{ mb: '36px' }} />
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: '50px' }}>
          {[1, 2, 3].map((i) => (
            <Box
              key={i}
              sx={{
                borderRadius: theme.novus.cardBorderRadius,
                border: theme.novus.cardBorderDefault,
                boxShadow: theme.novus.cardBoxShadow,
                p: theme.novus.cardPadding,
                bgcolor: theme.novus.sectionBgWhite,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              <Skeleton variant="text" width="60%" height={28} />
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <Skeleton variant="text" width={80} height={50} />
                <Skeleton variant="text" width={40} height={20} />
              </Box>
              <Skeleton variant="rectangular" width="100%" height={2} />
              {[1, 2, 3, 4].map((j) => (
                <Box key={j} sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width="70%" height={20} />
                </Box>
              ))}
              <Skeleton variant="rectangular" width="100%" height={2} />
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="rectangular" width="100%" height={44} sx={{ borderRadius: '5px' }} />
            </Box>
          ))}
        </Box>
      </Box>

      {/* CartFooter skeleton */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: theme.novus.novusFooterHeight,
          bgcolor: theme.novus.sectionBgWhite,
          zIndex: 1100,
          px: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={80} height={24} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: '5px' }} />
          <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: '5px' }} />
        </Box>
      </Box>
    </Box>
  );
};
